<template>
  <a-modal
    centered
    :title="title"
    :width="1000"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
   <div class="table-page-search-wrapper">
      <a-form class="div-query-banner" layout="inline" @keyup.enter.native="searchQuery">
        <a-form-item label="服务名称">
          <a-input placeholder="请输入服务名称" v-model="queryParam.name"></a-input>
        </a-form-item>
        <a-form-item label="地址ip">
          <a-input placeholder="ip地址" v-model="queryParam.serverId"></a-input>
        </a-form-item>
        <template v-if="toggleSearchStatus">
          <a-form-item label="端口号">
            <a-input placeholder="请输入端口号" v-model="queryParam.port"></a-input>
          </a-form-item>
          <a-form-item label="分类">
            <j-dict-select-tag placeholder="请选择分类" v-model="queryParam.type" dictCode="bus_server_service_type" />
          </a-form-item>
          <a-form-item label="是否启用">
            <a-input placeholder="请输入是否启用" v-model="queryParam.izActivity"></a-input>
          </a-form-item>
        </template>
        <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
        <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" >重置</a-button>
        <a @click="handleToggleSearch">
          {{ toggleSearchStatus ? '收起' : '展开' }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
        </a>
      </a-form>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
      </a-table>
    </div>
  </a-modal>
</template>


<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
    mixins:[JeecgListMixin],
    props: {
      title: {
        type: String,
        default: "添加服务"
      },
    },
    data() {
    return {
      visible: false,
      columns: [
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: '服务名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '所属服务器id',
          align: 'center',
          dataIndex: 'serverId_dictText',
        },
        {
          title: '端口号',
          align: 'center',
          dataIndex: 'port',
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '文件位置',
          align: 'center',
          dataIndex: 'fileSrc',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
      ],
      url: {
        list: '/servermanage/busServermanageService/list',
      },
    }
  },
  methods: {
    open(){
      this.initData();
      this.visible=true;
    },
    handleOk(){
      this.$emit("select",this.selectedRowKeys);
      this.visible=false;
    },
    handleCancel(){
      this.visible=false
    },
    initData() {
      this.onClearSelected();
      this.searchReset();
    }
  },
}
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
</style>